export enum AnuncioTipoEnum {
  GENERICO = 1,
  TIC = 2
}

export enum RepublicacaoMotivoEnum {
  CUMPRIU_LEI_14479 = 1,
  LIBERADO_DOADOR_LEI14479 = 2,
  FINALIZADO_PC_PARA_INCLUSAO = 3

}
